import React from 'react';
import { func,element,string } from 'prop-types';
import {TextType} from '../../../logics/questionBuilder';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style,{mobileStyle} from './style';

function MobilePresenter({editor,handleAddLeftsideOfBlankCode,handleAddRightsideOfBlankCode,handleMarkAsAnswer,selectedTextType,t,onClickHelp,className}){
	return (
		<mobileStyle.Wrapper className={className}>
			<h4>{t('create-quiz-modal.Edit')}</h4>
			<style.EditorWrapper>
				<style.ButtonWrapper>
					{t('create-quiz-modal.InputQuizHere')}
					<style.IconButton onClick={onClickHelp}>
						<style.QuestionIcon/>
					</style.IconButton>
					
				</style.ButtonWrapper>
				<style.Edditor>
					{editor}
				</style.Edditor>
				<style.Footer>
					{selectedTextType===TextType.NotAnswer ? (
						<div>
							<style.ConvertButton bsSize="small" onClick={handleMarkAsAnswer}>
								{'{  }'}
							</style.ConvertButton>
						</div>
					) : (
						<React.Fragment>
							<div>
								<style.ConvertButton bsSize="small" onClick={handleAddLeftsideOfBlankCode}>
									{'{'}
								</style.ConvertButton>
							</div>
							<div>
								<style.ConvertButton bsSize="small" onClick={handleAddRightsideOfBlankCode}>
									{'}'}
								</style.ConvertButton>
							</div>
						</React.Fragment>
					)}
					
				</style.Footer>
			</style.EditorWrapper>
		</mobileStyle.Wrapper>
	);
}
MobilePresenter.propTypes = {
	editor : element,
	onClickHelp : func.isRequired,
	t : func.isRequired,
	className : string,
	handleAddLeftsideOfBlankCode : func.isRequired,
	handleAddRightsideOfBlankCode : func.isRequired,
	handleMarkAsAnswer : func.isRequired,
	selectedTextType : string
};

export default withNamespaces()(MobilePresenter);